import { getGlobalCssUrl, getComponentCssUrl } from '../../Global/loadDependency'

// Lazy template creation to avoid calling getCdnUrl at module load time
function createNavEnterpriseMenuStylesTemplate() {
    const t = document.createElement('template')
    t.innerHTML = `
<link href="${getGlobalCssUrl()}" rel="stylesheet" />
<link href="${getComponentCssUrl('NavEnterpriseMenu--wc.css')}" rel="stylesheet" />
`
    return t
}

const getNavEnterpriseMenuStyles = () => createNavEnterpriseMenuStylesTemplate()
export { getNavEnterpriseMenuStyles }
